export const ErrorCodes = {
  notABusinessDay: 'date-not-a-business-day',
  outOfRange: 'date-out-of-range',
  outOfLeadTime: 'date-out-of-lead-time',
  unavailable: 'date-unavailable'
}
